import { render } from "./AdultConsent.vue?vue&type=template&id=e57b9154&scoped=true"
import script from "./AdultConsent.vue?vue&type=script&lang=js"
export * from "./AdultConsent.vue?vue&type=script&lang=js"

import "./AdultConsent.vue?vue&type=style&index=0&id=e57b9154&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e57b9154"]])

export default __exports__